import React, { useState, useEffect } from "react";

import UserService from "../services/user.service";
import EventBus from "../common/EventBus";
import { Table, Button, Container, Modal, Form, ButtonGroup, Pagination, Spinner, Popover, OverlayTrigger  } from 'react-bootstrap';
import ErrorModal from './ErrorModal';
import CustomModal from './CustomModal';

const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}; 





const BoardRequestData = () => {
  const [requestdata, setRequestdata] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  // State variables for date range filtering
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [selectedRequestdata, setSelectedRequestdata] = useState(null);
  const [deleteState, setDeleteState] = useState(false);
  const [errors, setErrors] = useState({}); // Error state
  const [apierrors, setApiErrors] = useState('');// Error state
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [filterTerm, setFilterTerm] = useState('');
  
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState(' Lade, bitte warten...');
  const [showModal, setShowModal] = useState(false);
  const [errorCode, setApiErrorCode] = useState('');// Error state

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(5); // Set items per page


  
  

  const handleRowClick = (row) => {
    console.log("Selected: "+row);
    console.log("Selected: "+JSON.stringify(requestdata[row]));
    setSelectedRequestdata(requestdata[row]);
  };

  const [formData, setFormData] = useState({
    
  });

  const validateForm = () => {
    const newErrors = {};
   /* if (!formData.recipient_email || !isValidEmail(formData.recipient_email)) {
      newErrors.recipient_email = 'Valid email is required';
    }
    if (!formData.subject || formData.subject.length < 3) {
      newErrors.subject = 'Subject should be at least 3 characters long';
    }
    if (!formData.body || formData.body.length < 10) {
      newErrors.body = 'Body should be at least 10 characters long';
    }*/
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    
    UserService.getRequestData().then(
      (response) => {
        setRequestdata(response.data);
      },
      (error) => {
        const _content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

          if (error.response) {
            // Server responded with a status other than 200 range
            setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
            setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
          } else if (error.request) {
            // Request was made, but no response was received
            setApiErrors('Fehler: Keine Antwort vom Server erhalten.');
            setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
          } else {
            // Other types of errors
            setApiErrors(`Fehler: ${error.response.data.message}`);
            setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
          } 

          setRequestdata(_content);

        if (error.response && error.response.status === 401) {
          EventBus.dispatch("logout");
        }
        
      
});
  }, [deleteState]);


  

  const keysToExclude = ['qr_code', 'batch_url_hash']; // Ersetze dies durch die Schlüssel, die du ausschließen möchtest

  const popover = (
    <Popover id="popover-basic" className="p-3 bg-light border border-danger" style={{ maxWidth: '400px' }}>
      <Popover.Header as="h3" className="bg-danger text-white">Batch-Code-Details</Popover.Header>
      <Popover.Body>
        {selectedRequestdata ? (
          <div>
            <strong>Details:</strong>
            {Object.entries(selectedRequestdata)
              .filter(([key]) => !keysToExclude.includes(key)) // Filtere die ausgeschlossenen Schlüssel heraus
              .map(([key, value]) => {
                // Prüfe, ob der Wert ein Objekt ist
                if (typeof value === 'object' && value !== null) {
                  return (
                    <div key={key}>
                      <strong>{key}:</strong>
                      {/* Rendere die Eigenschaften des verschachtelten Objekts */}
                      <div style={{ marginLeft: '15px' }}>
                        {Object.entries(value).map(([nestedKey, nestedValue]) => (
                          <p key={nestedKey}>
                            <strong>{nestedKey}:</strong> {nestedValue?.toString() || 'N/A'}
                          </p>
                        ))}
                      </div>
                    </div>
                  );
                }
                
                // Für Nicht-Objekt-Werte, zeige als Schlüssel-Wert-Paar an
                return (
                  <p key={key}>
                    <strong>{key}:</strong> {value?.toString() || 'N/A'}
                  </p>
                );
              })}
          </div>
        ) : (
          <p>Keine Daten ausgewählt</p>
        )}
      </Popover.Body>
    </Popover>
  );
  


 // Handle pagination
const handlePageChange = (pageNumber) => {
  setCurrentPage(pageNumber);
};



const filteredMainVOs = Array.isArray(requestdata)
  ? requestdata.filter((vo) => {
      // Normalize filterTerm for case insensitive comparison
      const normalizedFilterTerm = filterTerm.toLowerCase();

      // Filter by search term
      const termFilter =
     
        (vo.ip_address && vo.ip_address.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.country && vo.country.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.region && vo.region.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.city && vo.city.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.user_agent && vo.user_agent.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.status && vo.status.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.status_description && vo.status_description.toLowerCase().includes(normalizedFilterTerm)) ||
        (vo.batch_id && vo.batch_id.toString().includes(filterTerm)) || // Ensure filterTerm is used directly for batch_id
        (vo.request_timestamp && vo.request_timestamp.toLowerCase().includes(normalizedFilterTerm));

      // Ensure startDate and endDate are valid Date objects before comparing
      const requestDate = new Date(vo.request_timestamp);
      const dateFilter =
        (!startDate || requestDate >= new Date(startDate)) &&
        (!endDate || requestDate <= new Date(endDate));
        
      // Combine filters and return
      return termFilter && dateFilter; // Return the combined filter result
    })
  : []; // Return an empty array if requestdata is not an array

// Sorting function
const handleSort = (key) => {
  let direction = 'asc';
  if (sortConfig.key === key && sortConfig.direction === 'asc') {
    direction = 'desc';
  }
  setSortConfig({ key, direction });
};


// Sort the filtered data
const sortedMainVOs = [...filteredMainVOs].sort((a, b) => {
  if (a[sortConfig.key] < b[sortConfig.key]) {
    return sortConfig.direction === 'asc' ? -1 : 1;
  }
  if (a[sortConfig.key] > b[sortConfig.key]) {
    return sortConfig.direction === 'asc' ? 1 : -1;
  }
  return 0;
});



// Get the current page's data
const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;
const currentMainVOs = filteredMainVOs.slice(indexOfFirstItem, indexOfLastItem);

// Total pages calculation
const totalPages = Math.ceil(filteredMainVOs.length / itemsPerPage);

// Handle pagination

  const handleEditClick = (currency) => {
    setApiErrors(null);
    setApiErrorCode(null);
    setSelectedRequestdata(currency)
    setFormData(currency);
    setShowEditModal(true);
  };

  const handleCreateClick = () => {
    setApiErrors(null);
    setApiErrorCode(null);
    setFormData({
      
    });
    setShowCreateModal(true);
  };

  const isValidDate = (date) => {
    return !isNaN(Date.parse(date));
  };

  const handleDeleteClick = async (id,e) => {
    e.preventDefault();
    setApiErrors(null);
    setApiErrorCode(null);
    try {
      setLoadingText('Daten werden gelöscht, bitte warten...');
      setLoading(true);
      await UserService.deleteRequestData(id);
      setDeleteState(prev => !prev);
      console.info(deleteState);
    } catch (error) {
      setApiErrors(`Fehler: ${error.name}-${error.code} - ${error.response.data.message}-${error.response.data.error}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      setShowModal(true);

      console.error('Fehler beim Löschen der Weiterleitungen:', error);
    }
    finally {
      setLoading(false);
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      formData.rec_date = new Date();
      setLoadingText('Daten werden aktualisiert, bitte warten...');
      setLoading(true);
      await UserService.updateRequestData(selectedRequestdata.id,formData);
      setDeleteState(prev => !prev);
      setShowEditModal(false);
    } catch (error) {
      setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      console.error('Fehler beim Erstellen der Weiterleitung:', error);
      setShowModal(true);
    }
    finally {
      setLoading(false);
    }
  };

  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return; 
    try {
      
      formData.rec_date = new Date();
      const recDate = formData.createdAt;
      const validDate = isValidDate(recDate) ? recDate : null;     
      formData.createdAt = validDate;
      setLoadingText('Daten werden erstellt, bitte warten...');
      setLoading(true);
      await UserService.createRequestData(formData);
      setDeleteState(prev => !prev);
      setShowCreateModal(false);
      
    } catch (error) {
      setApiErrors(`Fehler: ${error.name} - ${error.response.data.message}-${error.code}`);
      setApiErrorCode(`Fehler: ${error.name} - ${error.code}`);
      console.error('Fehler beim Erstellen der Weiterleitung:', error);
      setDeleteState(prev => !prev);
      setShowModal(true);
      setShowCreateModal(false);
    }
    finally {
      setLoading(false);
    }
  };

  const handleBlur = () => {
    validateForm();
 };

 const handleChange = (e) => {
  const name = e.target.name;
  const value = e.target.value;
  console.log("Select Name:"+e.target.name);
  console.log("Select Value before :"+value); 
  setFormData({
     ...formData,
     [e.target.name]: e.target.value
   });
   console.log("Select Value before :"+formData); 
 //validateForm();
 };

 const handleCloseModal = () => setShowModal(false);

  return (
    <Container>
      <h1 className="mt-5">Weiterleitungsübersicht</h1>
      {/* Display error if it exists */}
      <ErrorModal show={showModal} handleClose={handleCloseModal} errorCode={errorCode} errorMessage={apierrors} />
      {/* Filter Input */}
      <Form.Group controlId="formBasicSearch">
        <Form.Control
          type="text"
          placeholder="Suche nach Betreff, Nachricht und Datum..."
          value={filterTerm}
          onChange={(e) => setFilterTerm(e.target.value)}
         
        />
      </Form.Group>

      {/* Date Filter Fields */}
      <Form.Group>
        <Form.Label>Startdatum:</Form.Label>
        <Form.Control
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
        />
      </Form.Group>
      <Form.Group>
        <Form.Label>Enddatum:</Form.Label>
        <Form.Control
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
        />
      </Form.Group>
      {loading && (
        <div className="spinner-overlay">
         <div className="spinner-background">
          <Spinner animation="border" role="status" className="spinner-border">
            <span className="sr-only">Lade...</span>
          </Spinner>
          <div className="spinner-text">...{loadingText}</div>
          </div>
        </div>
      )}

    
      {/* Table */}
      <Table striped bordered hover className="mt-4">
        <thead>
          <tr>
            {/* Sortable column headers */}
            <th onClick={() => handleSort('request_id')} style={{ cursor: 'pointer' }}>
            Weiterleitungs-ID {sortConfig.key === 'request_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('ip_address')} style={{ cursor: 'pointer' }}>
            IP-Adresse {sortConfig.key === 'ip_address' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('country')} style={{ cursor: 'pointer' }}>
            Land {sortConfig.key === 'country' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('region')} style={{ cursor: 'pointer' }}>
            Region {sortConfig.key === 'region' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('city')} style={{ cursor: 'pointer' }}>
            Stadt {sortConfig.key === 'city' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('user_agent')} style={{ cursor: 'pointer' }}>
            User-Agent {sortConfig.key === 'user_agent' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('status')} style={{ cursor: 'pointer' }}>
            Status {sortConfig.key === 'status' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('status_description')} style={{ cursor: 'pointer' }}>
            Statusbeschreibung {sortConfig.key === 'status_description' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('batch_id')} style={{ cursor: 'pointer' }}>
            Batch-ID {sortConfig.key === 'batch_id' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            <th onClick={() => handleSort('request_timestamp')} style={{ cursor: 'pointer' }}>
            Zeitstempel der Anfrage {sortConfig.key === 'request_timestamp' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
            </th>
            
          </tr>
        </thead>
        <tbody>
          {sortedMainVOs.map((vo,row,index) => (
           
           
           <OverlayTrigger
           key={`${vo.request_id}-${index}`}
           trigger="click"
           placement="right"
           overlay={popover}
           rootClose // Close popover on outside click
           onToggle={() => handleRowClick(row)} // Set row data on click
         >

            <tr key={vo.request_id}>
              <td>{vo.request_id}</td>
              <td>{vo.ip_address}</td>
              <td>{vo.country}</td>
              <td>{vo.region}</td>
              <td>{vo.city}</td>
              <td>{vo.user_agent}</td>
              <td>{vo.status}</td>
              <td>{vo.status_description}</td>
              <td>{vo.batch_id}</td>
              <td>{vo.request_timestamp}</td>
              
              
            </tr>
            </OverlayTrigger>
          ))}
        </tbody>
      </Table>
      <Pagination>
        <Pagination.First onClick={() => handlePageChange(1)} disabled={currentPage === 1} />
        <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} />

        {[...Array(totalPages)].map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePageChange(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}

        <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} />
        <Pagination.Last onClick={() => handlePageChange(totalPages)} disabled={currentPage === totalPages} />
      </Pagination>
      {/* Create Modal */}
      
    

      
  
    </Container>
  );
};

export default BoardRequestData;